<template>
  <div class="single-apply-area">
    <el-form
        :model="ruleForm"
        :rules="rules"
        ref="ruleForm"
        label-width="150px"
        class="demo-ruleForm"
        v-loading="loading"
    >
      <div class="upload-image">
        <div class="fz14 top-text">
          <div class="mb5" style="width: 100px">
            <span style="color: red" class="mr5">*</span>上传材料：
          </div>
          <div class="fc-407FFF pointer" @click="checkExampleDia">查看示例</div>
          <div class="fc-407FFF pointer" @click="downAuth">下载授权书</div>
        </div>
        <el-form-item label-width="0px" prop="businessLicenseId">
          <el-input style="display: none" v-model="ruleForm.businessLicenseId"></el-input>
          <el-upload
              class="avatar-uploader"
              multiple
              :show-file-list="false"
              :before-upload="(e) => handleBeforeUpload(e, 2)"
              :on-change="onChangeFront"
              action="/"
              accept="image/*"
          >
            <img class="image-card" v-if="imageLicenseId" :src="imageLicenseId" alt/>
            <img
                class="icon-check"
                v-if="imageLicenseId"
                @click.stop="checkImage('license')"
                src="@/assets/login/icon-check-img.png"
                alt
            />
            <img
                v-if="!imageLicenseId"
                src="@/assets/login/image-card-official.png"
                alt
            />
            <span v-if="!imageLicenseId" class="fz14 fc9">上传单位营业执照</span>
          </el-upload>
        </el-form-item>
        <el-form-item label-width="0px" prop="idCardFrontId">
          <el-input style="display: none" v-model="ruleForm.idCardFrontId"></el-input>
          <el-upload
              class="avatar-uploader"
              multiple
              :show-file-list="false"
              :before-upload="(e) => handleBeforeUpload(e, 0)"
              :on-change="onChangeFront"
              action="/"
              accept="image/*"
          >
            <img class="image-card" v-if="imageUrlFront" :src="imageUrlFront" alt/>
            <img
                class="icon-check"
                v-if="imageUrlFront"
                @click.stop="checkImage('front')"
                src="@/assets/login/icon-check-img.png"
            />
            <img v-if="!imageUrlFront" src="@/assets/login/image-card-people.png" alt/>
            <span v-if="!imageUrlFront" class="fz14 fc9">上传负责人身份证人像面照片</span>
          </el-upload>
        </el-form-item>
        <el-form-item label-width="0px" prop="idCardReserveId">
          <el-input style="display: none" v-model="ruleForm.idCardReserveId"></el-input>
          <el-upload
              class="avatar-uploader"
              multiple
              :show-file-list="false"
              :before-upload="(e) => handleBeforeUpload(e, 1)"
              :on-change="onChangeReserve"
              action="/"
              accept="image/*"
          >
            <img class="image-card" v-if="imageUrlReserve" :src="imageUrlReserve" alt/>
            <img
                class="icon-check"
                v-if="imageUrlReserve"
                @click.stop="checkImage('reserve')"
                src="@/assets/login/icon-check-img.png"
                alt
            />
            <img v-if="!imageUrlReserve" src="@/assets/login/image-card-emblem.png" alt/>
            <span v-if="!imageUrlReserve" class="fz14 fc9">上传负责人身份证国徽面照片</span>
          </el-upload>
        </el-form-item>
        <el-form-item label-width="0px" prop="authorizationId">
          <el-input style="display: none" v-model="ruleForm.authorizationId"></el-input>
          <el-upload
              class="avatar-uploader"
              multiple
              :show-file-list="false"
              :before-upload="(e) => handleBeforeUpload(e, 3)"
              :on-change="onChangeReserve"
              action="/"
              accept="image/*"
          >
            <img class="image-card" v-if="imageAuthorization" :src="imageAuthorization" alt/>
            <img
                class="icon-check"
                v-if="imageAuthorization"
                @click.stop="checkImage('auth')"
                src="@/assets/login/icon-check-img.png"
                alt
            />
            <img v-if="!imageAuthorization" style="width: 140px;" src="@/assets/login/image-card-auth.png" alt/>
            <span v-if="!imageAuthorization" class="fz14 fc9"
            >上传企业授权书照片</span>
          </el-upload>
        </el-form-item>
      </div>
      <el-row>
        <el-col :span="12">
          <el-form-item prop="businessCreditCode" label="信用代码">
            <el-input
                v-model="ruleForm.businessCreditCode"
                placeholder="请输入信用代码"
            ></el-input>
          </el-form-item>
          <div class="prompt">请对比信用代码识别的准确性</div>
        </el-col>
        <el-col :span="12">
          <el-form-item prop="businessName" label="单位名称">
            <el-input
                v-model="ruleForm.businessName"
                placeholder="请输入单位名称"
            ></el-input>
          </el-form-item>
          <div class="prompt">请对比单位名称识别的准确性</div>
        </el-col>
        <el-col :span="12">
          <el-form-item prop="name" label="负责人">
            <el-input
                v-model="ruleForm.name"
                placeholder="请输入负责人姓名"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item prop="idCard" label="负责人身份证号">
            <el-input
                v-model="ruleForm.idCard"
                placeholder="请输入负责人身份证号"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item prop="legalPersonName" label="法人">
            <el-input
                v-model="ruleForm.legalPersonName"
                placeholder="请输入法人姓名"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item prop="legalPersonIdCard" label="法人身份证号">
            <el-input
                v-model="ruleForm.legalPersonIdCard"
                placeholder="请输入法人身份证号"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item prop="telephone" label="手机号码">
            <el-input
                type="number"
                v-model="ruleForm.telephone"
                :maxlength="11"
                placeholder="请输入手机号码"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item prop="password" style="position: relative" label="登录密码">
            <el-input
                show-password
                v-model="ruleForm.password"
                placeholder="请输入登录密码"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item class="captcha-item" prop="smsCode" label="验证码">
            <el-input
                v-model="ruleForm.smsCode"
                placeholder="请输入短信验证码"
            ></el-input>
            <div v-if="!hadSend" class="get-cap" @click="getCaptcha">获取验证码</div>
            <div v-if="hadSend" class="get-cap">{{ count }}s重新获取</div>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item prop="email" label="邮箱">
            <el-input
                type="text"
                v-model="ruleForm.email"
                placeholder="请输入邮箱"
            ></el-input>
          </el-form-item>
        </el-col>
        <!-- <el-col :span="12">
          <el-form-item prop="inviteCode" label="邀请码">
            <el-input v-model="ruleForm.inviteCode" placeholder="请输入邀请码"></el-input>
          </el-form-item>
        </el-col> -->
      </el-row>
      <el-form-item>
        <el-button class="next-button" type="primary" @click="submitForm('ruleForm')"
        >确认无误，下一步
        </el-button
        >
      </el-form-item>
    </el-form>
    <el-image-viewer v-if="isShowPics" :on-close="closeViewer" :url-list="srcList"/>
    <verify-code ref="verifyRef" @getMessage="getMessage"></verify-code>
    <check-example ref="checkRef"></check-example>
    <face-check ref="faceRef" @subPersonSeal="subPersonSeal"></face-check>
  </div>
</template>
<script>
import verifyCode from "@/components/VerifyCode.vue";
import CheckExample from "./CheckExample.vue";
import ElImageViewer from "element-ui/packages/image/src/image-viewer";
import FaceCheck from "./FaceCheck.vue";
import Cookie from "js-cookie";

export default {
  components: {verifyCode, CheckExample, ElImageViewer, FaceCheck},
  data() {
    var validPass = (rule, value, callback) => {
      let reg = /(?!^(\d+|[A-Z]+|[a-z]+|[~!@#$%^&*?]+)$)^[\w~!@#$%^&*?]{8,16}$/;
      if (value === "") {
        callback(new Error("请输入设置您的登录密码"));
      } else if (!reg.test(value)) {
        callback(
            new Error(
                "密码长度为8-16位;必须包含大写字母、小写字母、数字和特殊字符中的两种或以上"
            )
        );
      } else {
        callback();
      }
    };
    var validIdCard = (rule, value, callback) => {
      let reg = /^[1-9]\d{5}(?:18|19|20)\d{2}(?:0[1-9]|10|11|12)(?:0[1-9]|[1-2]\d|30|31)\d{3}[\dXx]$/;
      if (value === "") {
        callback(new Error("请输入身份证号"));
      } else if (!reg.test(value)) {
        callback(new Error("请输入正确的身份证号"));
      } else {
        callback();
      }
    };
    var validPhone = (rule, value, callback) => {
      let reg = /^1[3456789]\d{9}$/;
      if (value === "") {
        callback(new Error("请输入实名手机号码"));
      } else if (!reg.test(value)) {
        callback(new Error("请输入实名手机号码"));
      } else {
        callback();
      }
    };
    var validCode = (rule, value, callback) => {
      let reg = /^[0-9A-HJ-NPQRTUWXY]{2}\d{6}[0-9A-HJ-NPQRTUWXY]{10}$/;
      if (value === "") {
        callback(new Error("请输入正确的统一社会信用代码"));
      } else if (!reg.test(value)) {
        callback(new Error("请输入正确的统一社会信用代码"));
      } else {
        callback();
      }
    };

    const validateEmail = (rule, value, callback) => {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (value === "") {
        callback(new Error("请输入电子邮箱"));
      } else if (!emailRegex.test(value)) {
        callback(new Error("请输入正确的电子邮箱"));
      } else {
        callback();
      }
    }
    return {
      baseUrl: 'api',
      imageUrlFront: "",
      imageUrlReserve: "",
      imageLicenseId: "",
      imageAuthorization: "",
      isShowPics: false,
      srcList: [],
      hadSend: false,
      count: 60,
      timer: null,
      loading: false,
      ruleForm: {
        name: undefined,
        idCard: undefined,
        email: undefined,
        telephone: undefined,
        password: undefined,
        smsCode: undefined,
        // inviteCode: undefined,
      },
      rules: {
        businessCreditCode: [{required: true, validator: validCode, trigger: "blur"}],
        businessName: [
          {required: true, message: "请输入正确的单位名称", trigger: "blur"},
        ],
        name: [{required: true, message: "请输入法人姓名", trigger: "blur"}],
        idCard: [{required: true, validator: validIdCard, trigger: "blur"}],
        legalPersonName: [{required: true, message: "请输入负责人姓名", trigger: "blur"}],
        legalPersonIdCard: [{required: true, validator: validIdCard, trigger: "blur"}],
        telephone: [{required: true, validator: validPhone, trigger: "blur"}],
        password: [{required: true, validator: validPass, trigger: "blur"}],
        smsCode: [{required: true, message: "请输入短信验证码", trigger: "blur"}],
        email: [
          {required: true, validator: validateEmail, trigger: "blur"},
        ],
        idCardFrontId: [
          {
            required: true,
            message: "请上传负责人身份证人像面照片",
            trigger: "change",
          },
        ],
        idCardReserveId: [
          {
            required: true,
            message: "请上传负责人身份证国徽面照片",
            trigger: "change",
          },
        ],
        businessLicenseId: [
          {
            required: true,
            message: "请上传单位营业执照",
            trigger: "change",
          },
        ],
        authorizationId: [
          {
            required: true,
            message: "请上传企业授权书照片",
            trigger: "change",
          },
        ],
      },
      raw: null,
    };
  },
  methods: {
    downAuth() {
      top.window.location.href = this.baseUrl + this.$api.register.downAuth
    },
    checkExampleDia() {
      this.$refs.checkRef.show("official");
    },
    request(base, type) {
      let params = {
        type: '' + type,
        imageBase64: base,
      };
      this.loading = true;
      this.$http.post(this.$api.register.upload, params).then((res) => {
        if (res.data.code == 200) {
          if (type == 0) {
            if (res.data.data.name) {
              this.$set(this.ruleForm, "legalPersonName", res.data.data.name);
              this.$set(this.ruleForm, "name", res.data.data.name);
            }
            if (res.data.data.idCard) {
              this.$set(this.ruleForm, "idCard", res.data.data.idCard);
              this.$set(this.ruleForm, "legalPersonIdCard", res.data.data.idCard);
            }
            this.$set(this.ruleForm, "idCardFrontId", res.data.data.imageId);
          } else if (type == 1) {
            this.$set(this.ruleForm, "idCardReserveId", res.data.data.imageId);
          } else if (type == 2) {
            this.$set(this.ruleForm, "businessLicenseId", res.data.data.imageId);
            if (res.data.data.businessName) {
              this.$set(this.ruleForm, "businessName", res.data.data.businessName);
            }

            if (res.data.data.businessCode) {
              this.$set(this.ruleForm, "businessCreditCode", res.data.data.businessCode);
            }
          } else if (type == 3) {
            this.$set(this.ruleForm, "authorizationId", res.data.data.imageId);
          }

          this.$message.success(res.data.msg);
        } else {
          this.$message.error(res.data.msg);
        }
        this.loading = false;
      });
    },
    handleBeforeUpload(file, type) {
      const reader = new FileReader();
      reader.readAsDataURL(file); // 转换为Base64
      reader.onload = (e) => {
        if (type == 0) {
          this.imageUrlFront = e.target.result;
        } else if (type == 1) {
          this.imageUrlReserve = e.target.result;
        } else if (type == 2) {
          this.imageLicenseId = e.target.result;
        } else if (type == 3) {
          this.imageAuthorization = e.target.result;
        }
        let position = e.target.result.indexOf("base64");
        let lastIndex = position * 1 + 7;
        let base = e.target.result.slice(lastIndex);
        this.request(base, type);
      };
      return false; // 阻止默认上传行为
    },
    onChangeFront(file, fileList) {
      if (fileList.length > 1) {
        fileList.splice(0, 1);
      }
    },
    onChangeReserve(file, fileList) {
      if (fileList.length > 1) {
        fileList.splice(0, 1);
      }
    },
    handlePictureCardPreview() {
    },
    getCaptcha() {
      if (!this.ruleForm.telephone) {
        this.$message.warning("请先输入手机号码");
        return;
      }
      this.$refs.verifyRef.show();
    },
    getMessage(param) {
      let params = param;
      params.telephone = this.ruleForm.telephone;
      params.type = 'register';
      this.loading = true;
      this.$http.post(this.$api.register.sendSMSCode, params).then((res) => {
        this.loading = false;
        if (res.data.code == 200) {
          this.$message.success(res.data.msg);
          this.hadSend = true;
          this.count = 60;
          this.timer = setInterval(() => {
            if (this.count > 1) {
              this.count--;
            } else {
              if (this.timer) {
                this.hadSend = false;
                clearInterval(this.timer);
              }
            }
          }, 1000);
        } else {
          this.$message.error(res.data.msg);
        }
      });
    },
    submitForm() {
      this.$refs.ruleForm.validate((value) => {
        if (value) {
          this.$refs.faceRef.show(this.ruleForm, "负责人");
          // let phoneParams = {
          //   phone: this.ruleForm.telephone,
          //   smsCode: this.ruleForm.smsCode
          // };
          // this.loading = true;
          // this.$http
          //   .post(this.$api.register.verifySMSCode, phoneParams)
          //   .then(res => {
          //     this.loading = false;
          //     if (res.data.code == 200) {
          //       let temp = JSON.parse(JSON.stringify(this.ruleForm));
          //       temp.name = temp.name;
          //       temp.idCard = temp.idCard;
          //       this.$refs.faceRef.show(temp, "法定代表人");
          //     } else {
          //       this.$message.error(res.data.msg);
          //     }
          //   });
        }
      });
    },
    subPersonSeal(checkId) {
      let params = {
        ...this.ruleForm,
        checkId: checkId,
      };
      this.loading = true;
      this.$http.post(this.$api.register.submitBusinessSeal, params).then((res) => {
        this.loading = false;
        if (res.data.code == 200) {
          Cookie.set("businessCreditCode", res.data.data.businessCreditCode);
          this.$auth.setUserId(res.data.data.userId);
          this.$router.push({
            path: "/register/officialConfirm",
          });
        } else {
          this.$message.error(res.data.msg);
        }
      });
    },
    checkImage(flag) {
      this.srcList = [];
      if (flag == "front") {
        this.srcList.push(this.imageUrlFront);
      } else if (flag == "license") {
        this.srcList.push(this.imageLicenseId);
      } else if (flag == "reserve") {
        this.srcList.push(this.imageUrlReserve);
      } else {
        this.srcList.push(this.imageAuthorization);
      }
      this.isShowPics = true;
    },
    closeViewer() {
      this.isShowPics = false;
    },
  },
};
</script>
<style lang="less" scoped>
::v-deep .el-form-item__error {
  background-color: #ffffff;
  width: 100%
}

.prompt {
  margin-top: -28px;
  font-size: 12px;
  text-align: left;
  padding-left: 150px;
  color: #409EFF;
  margin-bottom: 11px;
}

.single-apply-area {
  margin-left: 112px;
  margin-right: 112px;

  .upload-image {
    display: flex;
    align-items: flex-start;
    margin-bottom: 22px;

    .top-text {
      display: flex;
      flex-direction: column;
      align-items: center;
      width: 100px;
    }
  }

  .captcha-item {
    position: relative;
  }

  .get-cap {
    position: absolute;
    right: 20px;
    top: 0px;
    color: #407fff;
    cursor: pointer;
  }

  .next-button {
    width: 350px;
    font-size: 16px;
    padding: 11px 20px !important;
    margin-top: 40px;
    box-shadow: 0 2px 4px 0 rgba(64, 129, 255, 0.4);
  }
}

.avatar-uploader {
  position: relative;
  width: 210px;
  height: 160px;
  margin-right: 30px;
  background: #f5f7fa;
  border: 1px solid #f5f5f5;

  .image-card {
    height: 100%;
  }

  .icon-check {
    position: absolute;
    bottom: 0;
    right: 0;
  }
}

::v-deep .el-upload {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

//去掉number输入框的上下箭头
::v-deep input::-webkit-outer-spin-button {
  -webkit-appearance: none;
}

::v-deep input::-webkit-inner-spin-button {
  -webkit-appearance: none;
}

::v-deep input[type="number"] {
  -moz-appearance: textfield;
}

// 解决input number框输入中文后光标上移的问题
::v-deep .el-input__inner {
  line-height: 1px !important;
}

::v-deep .el-form-item {
  margin-bottom: 28px !important;
}

::v-deep .el-form-item__error {
  text-align: left !important;
}
</style>
